import router from '../router'
import store from '../vuex/store'
import api from "@/api/homepage.js";
import { Message, MessageBox } from 'element-ui'


router.beforeEach((to, from, next) => {
    // console.log(to)
    // console.log(from)
    if(to.meta.auth == true){
        api.ticketAppUser({}).then(res=>{
            store.commit('lang', 'zh')
            next()
        }).catch(error=>{
            Message({
                message: '票务系统温馨提示：您还没有登录，或登录已失效，请重新登录',   
                type: 'error'
            })
            next({path:'/login'})
        }) 
    }else{
        store.commit('lang', 'zh')
        next()
    }  
    

})








// WEBPACK FOOTER //
// ./src/language/lang.js